module.exports = __webpack_public_path__ + "static/john.15d64f55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awards_ceremony/john.png
// module id = 557
// module chunks = 138584234813021